import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import "uikit/dist/css/uikit-rtl.min.css";
import "@flaticon/flaticon-uicons/css/all/all.css";
import "./assets/css/style.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "./config/AxiosConfig";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
UIkit.use(Icons);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
